import { render } from "./freeOther.vue?vue&type=template&id=1b9434fa&ts=true"
import script from "./freeOther.vue?vue&type=script&lang=ts"
export * from "./freeOther.vue?vue&type=script&lang=ts"

import "./freeOther.vue?vue&type=style&index=0&id=1b9434fa&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__